import { Arrow } from "@/src/svg/Arrow";
import "./style.scss";
import { SubmitHandler, useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import { PhoneInputController } from "../PhoneInputController/PhoneInputController";
import axiosInstance from "@/src/api/axiosInstance";
import FormSuccess from "../FormSuccess/FormSuccess";
import { useState } from "react";

interface IContactForm {
  name: string;
  phone: string;
  email: string;
}

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm<IContactForm>();
  const [stateFormSuccess, setStateFormSuccess] = useState<boolean>(false);
  const [formData, setFormData] = useState<IContactForm | null>(null);

  const onSubmit: SubmitHandler<IContactForm> = async (data) => {
    const formData = new FormData();

    formData.append("fullname", data.name);
    formData.append("phone", data.phone);
    formData.append("email", data.email);
    formData.append("form_type", "short");

    // formData.forEach((value, key) => {
    //   console.log(`${key}: ${value}`);
    // });

    try {
      const response = await axiosInstance.post("/form", formData);
      console.log("Успешно отправлено:", response.data);
      setStateFormSuccess(true);
      reset();
    } catch (error: any) {
      console.error("Ошибка при отправке формы:", error?.response?.data || error.message);
    }
  };

  return (
    <>
      <Link to={"/apply-online"} className="apply-online-btn btn-default reverse">
        Оставить заявку
      </Link>
      <form onSubmit={handleSubmit(onSubmit)} className="contact-form">
        <div className="contact-form-title">
          <p>Быстрая заявка</p>
        </div>
        <div className="contact-form-inputs">
          <div className="contact-form-input">
            <input
              placeholder="Полное Имя:"
              {...register("name", { required: "Name is required" })}
            />
            {errors.name && <p className="Error">{errors.name.message}</p>}
          </div>
          <div className="contact-form-input">
            <PhoneInputController
              name="phone"
              control={control}
              rules={{ required: "Phone is required" }}
            />
            {errors.phone && <p className="error">{errors.phone.message}</p>}
          </div>

          <div className="contact-form-input">
            <input
              placeholder="Email:"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Enter a valid email",
                },
              })}
            />
            {errors.email && <p className="error">{errors.email.message}</p>}
          </div>
        </div>
        <div className="contact-form-button">
          <button type="submit">Отправить</button>
        </div>
        <div
          className="contact-form-arrow-up"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          <Arrow />
        </div>
      </form>
      <FormSuccess stateFormSuccess={stateFormSuccess} setStateFormSuccess={setStateFormSuccess} />
    </>
  );
};

export default ContactForm;
